/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type WorkOrderFragment = {
  __typename?: 'WorkOrder'
  createdAt: string
  description: string | null
  dueAt: string | null
  id: string
  orderNumber: number
  priority: Types.WorkOrderPriority | null
  regionID: string | null
  status: Types.WorkOrderStatus
  serviceCategory: Types.WorkOrderServiceCategory | null
  serviceItem: Types.WorkOrderServiceItem
  statusChangedAt: string | null
  updatedAt: string
  assignee: {
    __typename?: 'BackofficeUser'
    id: string
    firstName: string
    lastName: string
  } | null
  createdBy: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
  statusChangedBy: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    isWheelchairAccessible: boolean
    isSelfDriving: boolean
    label: number | null
    baseServiceBreakLocation: {
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
    } | null
    currentlyLocatedInServiceBreakLocation: {
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
    } | null
    fleet: { __typename?: 'Fleet'; name: string } | null
    inVehicleLists: Array<{
      __typename?: 'VehicleList'
      id: string
      name: string
    }>
  } | null
}

export const WorkOrderFragmentDoc = gql`
    fragment WorkOrder on WorkOrder {
  assignee {
    id
    firstName
    lastName
  }
  createdAt
  createdBy {
    firstName
    lastName
  }
  description
  dueAt
  id
  orderNumber
  priority
  regionID
  status
  serviceCategory
  serviceItem
  statusChangedAt
  statusChangedBy {
    firstName
    lastName
  }
  updatedAt
  vehicle {
    baseServiceBreakLocation {
      id
      name
    }
    currentlyLocatedInServiceBreakLocation {
      id
      name
    }
    fleet {
      name
    }
    id
    isWheelchairAccessible
    isSelfDriving
    label
    inVehicleLists {
      id
      name
    }
  }
}
    `
